// import { Product } from '../types/product'
import BlackTeaIcon from '../assets/icons/BlackTeaIcon';
import GreenTeaIcon from '../assets/icons/GreenTeaIcon';
import HerbalTeaIcon from '../assets/icons/HerbalTeaIcon';
import FruitTeaIcon from '../assets/icons/FruitTeaIcon';
import WaterIcon from '../assets/icons/WaterIcon';
import SodaIcon from '../assets/icons/SodaIcon';
import SnackIcon from '../assets/icons/SnackIcon';

// Yardımcı: mainCategory veya main_category'yı normalize et
function getMainCategoryId(product: any): string {
  return product.main_category_id;
}

// Kategori adlarını id'den almak için yardımcı fonksiyonlar
type CategoryNameMap = { [key: string]: string };
const MAIN_CATEGORY_NAMES: CategoryNameMap = {
  '1': 'Sıcak İçecekler',
  '2': 'Soğuk İçecekler',
  '3': 'Atıştırmalıklar',
};
const SUB_CATEGORY_NAMES: CategoryNameMap = {
  '4': 'Kuşburnu',
  '5': 'Jasmin Çayı',
  '6': 'Ihlamur',
  '7': 'Kırmızı Orman Meyveli',
  '8': 'Klasik Siyah Çay',
  '9': 'Su',
  '10': 'Soda',
  '11': 'Meyveli Soda',
  '12': 'Ice Tea',
  '13': 'Ayran',
  '14': 'Limonata',
  '15': 'Gazoz',
  '16': 'Enerji İçeceği',
  '17': 'Gofret',
  '18': 'Bisküvi',
  '19': 'Çikolatalı Gofret',
  '20': 'Kraker',
  '21': 'Cips',
  '22': 'Kek',
  '23': 'Çubuk Kraker',
  '24': 'Kuruyemiş',
};

export function getMainCategoryName(main_category_id: string): string {
  return MAIN_CATEGORY_NAMES[main_category_id] || 'Kategori';
}
export function getSubCategoryName(category_id: string): string {
  return SUB_CATEGORY_NAMES[category_id] || 'Alt Kategori';
}

export const getGeneralSubCategory = (product: any): string => {
  const mainCategory = getMainCategoryId(product);
  if (mainCategory === 'cold') {
    if (['water', 'soda'].includes(product.category)) {
      return 'water-soda';
    }
    if (['fruit-soda', 'gazoz'].includes(product.category)) {
      return 'fruit-gas';
    }
    if (['ayran'].includes(product.category)) {
      return 'milk-ayran';
    }
    if (['ice-tea', 'lemonade'].includes(product.category)) {
      return 'tea-lemonade';
    }
    if (['energy-drink'].includes(product.category)) {
      return 'energy';
    }
  }
  if (mainCategory === 'snack') {
    if (['wafer', 'biscuit', 'choco-wafer'].includes(product.category)) {
      return 'wafer-biscuit';
    }
    if (['cracker', 'stick-cracker'].includes(product.category)) {
      return 'cracker-stick';
    }
    if (['chips'].includes(product.category)) {
      return 'chips';
    }
    if (['cake'].includes(product.category)) {
      return 'cake';
    }
    if (['nuts'].includes(product.category)) {
      return 'nuts';
    }
  }
  return product.category;
};

export const getCategoryName = (mainCategory: string, category: string): string => {
  if (mainCategory === 'hot') {
    switch (category) {
      case 'black':
        return 'Siyah Çay';
      case 'green':
        return 'Yeşil Çay';
      case 'herbal':
        return 'Bitki Çayı';
      case 'fruit':
        return 'Meyve Çayı';
      default:
        return 'Çay';
    }
  }
  if (mainCategory === 'cold') {
    switch (category) {
      case 'water':
        return 'Su';
      case 'soda':
        return 'Soda';
      case 'fruit-soda':
        return 'Meyveli Soda';
      default:
        return 'Soğuk İçecek';
    }
  }
  if (mainCategory === 'snack') {
    switch (category) {
      case 'wafer':
        return 'Gofret';
      case 'biscuit':
        return 'Bisküvi';
      case 'choco-wafer':
        return 'Çikolatalı Gofret';
      default:
        return 'Atıştırmalık';
    }
  }
  return 'Ürün';
};

export const filterProducts = (
  products: any[],
  selectedMainCategory: string,
  selectedSubCategory: string
): any[] => {
  return products.filter(product => {
    const mainCategory = getMainCategoryId(product);
    const matchesMain = selectedMainCategory === 'all' || mainCategory === selectedMainCategory;
    const generalSub = getGeneralSubCategory(product);
    const matchesSub = selectedSubCategory === 'all' || generalSub === selectedSubCategory;
    return matchesMain && (selectedMainCategory === 'all' || matchesSub);
  });
};

export function getProductImage(
  mainCategory: string,
  category: string,
  className: string = 'w-full h-36 object-contain'
): React.ReactNode {
  switch (mainCategory) {
    case '1': // Sıcak İçecekler
      switch (category) {
        case '8': // Klasik Siyah Çay
          return <BlackTeaIcon className={className} />;
        case '5': // Jasmin Çayı (Yeşil)
          return <GreenTeaIcon className={className} />;
        case '6': // Ihlamur (Bitki)
          return <HerbalTeaIcon className={className} />;
        case '4': // Kuşburnu
        case '7': // Kırmızı Orman Meyveli
          return <FruitTeaIcon className={className} />;
        default:
          return <BlackTeaIcon className={className} />;
      }
    case '2': // Soğuk İçecekler
      switch (category) {
        case '9': // Su
          return <WaterIcon className={className} />;
        case '10': // Soda
        case '11': // Meyveli Soda
        case '15': // Gazoz
        case '16': // Enerji İçeceği
          return <SodaIcon className={className} />;
        case '12': // Ice Tea
        case '14': // Limonata
        case '13': // Ayran
          return <FruitTeaIcon className={className} />;
        default:
          return <SodaIcon className={className} />;
      }
    case '3': // Atıştırmalıklar
      return <SnackIcon className={className} />;
    default:
      return <BlackTeaIcon className={className} />;
  }
}
